import * as React from 'react';
import { graphql } from 'gatsby';
import Main from "../components/Main";
import TitleBanner from '../components/TitleBanner';
import CardGrid from '../components/CardGrid';
import Logos from '../components/Logos';

import CJALogo from '../assets/images/client-logos/cja.svg';
import UofALogo from '../assets/images/client-logos/u-of-a.svg';
import UBCLogo from '../assets/images/client-logos/ubc.svg';
import ADLogo from '../assets/images/client-logos/ad-tutoring.svg';
import RMALogo from '../assets/images/client-logos/rma.svg';

// GraphQL query to fetch data
export const query = graphql`
  {
    allFile(filter: { relativeDirectory: { in: "case-studies/thumbnails" } }) {
      nodes {
        relativePath
        childrenImageSharp {
          id
          gatsbyImageData(aspectRatio: 1.2, width: 568)
        }
      }
    }
  }
`;

const cards = [
  {
    title: 'Alberta Motor Association (AMA)',
    image: 'case-studies/thumbnails/ama-thumbnail.jpg',
  },
  {
    title: 'Emily Carr University of Art + Design',
    image: 'case-studies/thumbnails/ecu-thumbnail.jpg',
  },
];

const governmentPage = ({ data }) => {
  // Logic to create imageMap and cardsWithImages using the 'data' prop
  const imageMap = data.allFile.nodes.reduce((acc, node) => {
    acc[node.relativePath] = node.childrenImageSharp[0].gatsbyImageData;
    return acc;
  }, {});

  const cardsWithImages = cards.map((card) => ({
    ...card,
    gatsbyImageData: imageMap[card.image],
  }));

  // Example logo array
  const logoArray = [
    {
      id: 1,
      name: 'Rural Municipalities of Alberta',
      LogoComponent: RMALogo,
      alt: 'Rural Municipalities of Alberta Logo',
    },
    {
      id: 2,
      name: 'University of Alberta',
      LogoComponent: UofALogo,
      alt: 'University of Alberta Logo',
    },
    {
      id: 3,
      name: 'University of British Columbia',
      LogoComponent: UBCLogo,
      alt: 'University of British Columbia Logo',
    },
    {
      id: 4,
      name: 'A&D Tutoring',
      LogoComponent: ADLogo,
      alt: 'A&D Tutoring Logo',
    },
    {
      id: 5,
      name: 'Calgary Jewish Academy',
      LogoComponent: CJALogo,
      alt: 'Calgary Jewish Academy Logo',
      height: '100'
    },
    // Add more logos as needed
  ];

  return (
    <Main>
      <TitleBanner
        title="Government &amp; Education"
        sectionTitle="Our Work"
      />
      <CardGrid items={cardsWithImages} />
      <Logos logos={logoArray} />
    </Main>
  );
};

export default governmentPage;

export function Head() {
  return (
    <>
      <html lang="en" />
      <title>We Are Pixel | Government &amp; Education</title>
      <meta
        name="description"
        content="Browse government and education sites from Pixel's portfolio"
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Browse government and education sites from Pixel's portfolio"
      />
      <meta
        property="og:url"
        content="https://wearepixel.ca/government-education"
      />
      <meta property="og:site_name" content="Pixel" />
    </>
  );
}
